import { render, staticRenderFns } from "./CompFrame.vue?vue&type=template&id=1f070548&scoped=true&"
import script from "./CompFrame.vue?vue&type=script&lang=js&"
export * from "./CompFrame.vue?vue&type=script&lang=js&"
import style0 from "./CompFrame.vue?vue&type=style&index=0&id=1f070548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f070548",
  null
  
)

export default component.exports